'use client'

import React from 'react'
import { useTranslation } from 'react-i18next'
import { Reveal } from '@/components/site/reveal'
import { SectionHead } from '@/components/site/section-head'
import { SiteSection } from '@/components/site/section'

const TEMPLATE_CARDS = [
  { id: 'general', builtin: true, tagIds: ['summary', 'decisions', 'todos', 'open'] },
  { id: 'decisions', builtin: true, tagIds: ['decisions', 'todos'] },
  { id: 'interview', builtin: true, tagIds: ['summary', 'quotes', 'followups'] },
  { id: 'custom', builtin: false, tagIds: ['custom', 'personal', 'teamShared'] },
  { id: 'rerun', builtin: false, tagIds: ['multipleRuns'] },
  { id: 'upload', builtin: false, tagIds: ['batch', 'automatic'] },
] as const

export function NotesTemplatesSection() {
  const { t } = useTranslation(['web'])

  return (
    <SiteSection divider trackingKey="templates">
      <Reveal>
        <SectionHead
          eyebrow={t('web:meetingNotesPage.templates.eyebrow')}
          titleKey="web:meetingNotesPage.templates.title"
          lead={t('web:meetingNotesPage.templates.lead')}
        />
      </Reveal>
      <Reveal className="mt-(--gap-lg)">
        <div className="grid grid-cols-3 gap-x-(--gap-lg) max-[880px]:grid-cols-1">
          {TEMPLATE_CARDS.map(({ id, builtin, tagIds }, index) => (
            <article
              key={id}
              className={`border-t py-[18px] ${
                index < 3 ? 'border-foreground max-[880px]:border-border' : 'border-border'
              } ${index === 0 ? 'max-[880px]:border-foreground' : ''}`}
            >
              <h3 className="mb-1.5 flex items-center gap-2 text-lg-plus font-semibold">
                {t(`web:meetingNotesPage.templates.cards.${id}.title`)}
                {builtin ? <TemplateTag label={t('web:meetingNotesPage.templates.builtin')} /> : null}
              </h3>
              <p className="text-md leading-[1.65] text-muted">
                {t(`web:meetingNotesPage.templates.cards.${id}.description`)}
              </p>
              <div className="mt-2.5 flex flex-wrap gap-1.5">
                {tagIds.map((tagId) => (
                  <TemplateTag
                    key={tagId}
                    label={t(`web:meetingNotesPage.templates.tags.${tagId}`)}
                  />
                ))}
              </div>
            </article>
          ))}
        </div>
      </Reveal>
    </SiteSection>
  )
}

function TemplateTag({ label }: { label: string }) {
  return (
    <span className="inline-flex items-center rounded-full border border-border px-2.5 py-[3px] font-mono text-[11px] tracking-[0.08em] text-muted">
      {label}
    </span>
  )
}
